import { render } from "./Footer-Component.vue?vue&type=template&id=2f7cca98"
import script from "./Footer-Component.vue?vue&type=script&lang=js"
export * from "./Footer-Component.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__